<template>
  <div class="flight_action border-g1 border-t justify-end py-3 px-3" v-if="deviceCanPlayMission()">
    <div class="flex w-full" v-if="Number.isInteger(config.flight.flg_id)">

      <!-- <div class="flex">
        <div class="btn_action start" @click="flight_start()" v-if="canStart">
          START
        </div>
      </div> -->

      <div class="flight_action_btn" @click="flight_pause()" v-if="canResumeOrPause && !isPaused">
        <svg class="fill-current" width="13" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 18V0H6V18H0ZM10 18V0H16V18H10Z" />
        </svg>
      </div>

      <div class="flight_action_btn" @click="flight_resume()" v-if="canResumeOrPause && isPaused">
        <svg class="fill-current" width="12" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0V18L16 9L0 0Z" />
        </svg>
      </div>
    </div>

    <div class="flex relative">
      <!-- <div class="flight_action_btn" @click="supplLight()" v-if="config?.dock?.id != undefined">
        <svg class="fill-current" xmlns="http://www.w3.org/2000/svg" width="13.5" viewBox="0 0 70 100">
          <path
            d="M80,55.428V30a30,30,0,0,0-60,0V55.429A7.5,7.5,0,0,0,22.5,70H30v30h5V70H65v30h5V70h7.5A7.5,7.5,0,0,0,80,55.428ZM52.5,41.035V55h-5V41.035l-9.268-9.268,3.535-3.535L50,36.465l8.232-8.232,3.535,3.535Z"
            transform="translate(-15)" />
        </svg>

        <div v-if="light" class="absolute w-[40px] h-[3px] bg-debug origin-center -rotate-45"></div>
      </div> -->

      <div
        id="flight_action_btn_control_panel"
        class="flight_action_btn"
        @click="config.flight.openControlPanel = !config.flight.openControlPanel"
        :class="(config.flight.openControlPanel ? 'active' : '') + ' ' + drcModeCss"
        v-if="$root.user.can([3,4,5], 'DEVICES.DRC.drc_access')"
      >
        <svg class="fill-current" xmlns="http://www.w3.org/2000/svg" width="20.501" height="15.176"
          viewBox="0 0 20.501 15.176">
          <g transform="translate(0 -40.159)">
            <path d="M8.976,68.784a2.576,2.576,0,0,0-5.059,0Z" transform="translate(-2.614 -19.04)" />
            <path d="M3.917,75.9a2.576,2.576,0,0,0,5.059,0Z" transform="translate(-2.614 -25.185)" />
            <circle cx="0.398" cy="0.398" r="0.398" transform="translate(3.435 49.833)" />
            <path
              d="M19.781,60.685s-1.652-1.023-6.735-.91a8.173,8.173,0,0,1-2.8.569,8.176,8.176,0,0,1-2.8-.569c-5.083-.114-6.735.91-6.735.91C.314,61.2,0,61.5,0,64.924c0,1.191.038,2.311.1,3.287a18.36,18.36,0,0,0,6.523,1.517l.294.025h6.662l.293-.025A18.358,18.358,0,0,0,20.4,68.211c.066-.976.1-2.1.1-3.287C20.5,61.5,20.186,61.2,19.781,60.685ZM3.833,67.56a2.912,2.912,0,1,1,2.911-2.912A2.912,2.912,0,0,1,3.833,67.56Zm12.836,0a2.912,2.912,0,1,1,2.911-2.912A2.912,2.912,0,0,1,16.668,67.56Z"
              transform="translate(0 -14.417)" />
            <path d="M5.059,2.09A2.576,2.576,0,0,0,0,2.09Z" transform="translate(14.092 52.761) rotate(-90)" />
            <path d="M0,0A2.577,2.577,0,0,0,2.53,2.09,2.577,2.577,0,0,0,5.059,0Z"
              transform="translate(17.155 52.761) rotate(-90)" />
            <circle cx="0.398" cy="0.398" r="0.398" transform="translate(16.27 49.833)" />
            <path
              d="M14.807,35.354h-2.1c-.722,0-1.309.387-1.309.862V37.23q.252-.02.524-.038v-.977c0-.285.352-.517.785-.517h2.1v-.345Z"
              transform="translate(-5.323 7.932)" />
            <path
              d="M35.151,35.354H32.945V35.7H35.15c.433,0,.785.232.785.517v.97q.271.018.524.038V36.216C36.46,35.741,35.872,35.354,35.151,35.354Z"
              transform="translate(-22.038 7.932)" />
            <rect width="0.667" height="4.737" transform="translate(9.917 40.735)" />
            <rect width="1.334" height="0.381" transform="translate(9.583 40.159)" />
          </g>
        </svg>
      </div>

      <template v-if="haveParachute">
        <div
          class="flight_action_btn"
          @click="fireParachute()"
          v-if="$root.user.can([3,4,5], 'DEVICES.FTS.fire')"
        >
          <svg class="fill-current" xmlns="http://www.w3.org/2000/svg" width="20.437" height="19.211"
            viewBox="0 0 20.437 19.211">
            <path
              d="M12.719,5.4C7.082,5.4,2.5,9.122,2.5,13.726a.391.391,0,0,0,.129.3L12.4,24.461a.5.5,0,0,0,.323.151.416.416,0,0,0,.323-.151l9.767-10.412a.425.425,0,0,0,.129-.3C22.937,9.122,18.355,5.4,12.719,5.4Zm0,7.185a3.368,3.368,0,0,1,2.668.9.482.482,0,0,1,.022.387l-2.689,8.67L10.03,13.855a.474.474,0,0,1,0-.344A3.241,3.241,0,0,1,12.719,12.585Zm-6.475,0c1.7,0,2.646.645,2.775,1.14l2.711,8.713L3.511,13.661C3.6,13.188,4.63,12.585,6.243,12.585ZM16.4,13.726c.172-.559,1.076-1.14,2.8-1.14,1.613,0,2.625.6,2.732,1.076l-8.218,8.777Z"
              transform="translate(-2.5 -5.4)" />
          </svg>
        </div>
      </template>

      <template v-if="config?.drone?.id != undefined && !$root.isPopup">
        <div class="flight_action_btn" :class="{ 'active': this.config.drone.hideFrustrum == false }"
          v-if="DroneLastPingAreOnline" @click="toogleDroneFrustrum()">
          <svg class="fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.62 8.49">
            <polygon points="12.62 8.49 0 8.49 1.73 2.51 10.89 2.51 12.62 8.49" style="opacity:.3;" />
            <path d="M6.31.5l5.71,7.69H.6L6.31.5M6.31,0L0,8.49h12.62L6.31,0h0Z" />
            <path d="M7.37.92l3.27,1.79,1.23,4.27L7.37.92M6.31,0l6.31,8.49-1.73-5.99L6.31,0h0Z" />
            <path d="M5.25.92L.75,6.98,1.98,2.71l3.27-1.79M6.31,0L1.73,2.51,0,8.49,6.31,0h0Z" />
            <path d="M6.31.34l3.41,1.87H2.9L6.31.34M6.31,0L1.73,2.51h9.17L6.31,0h0Z" />
          </svg>
        </div>
      </template>

      <button @click="flight_rth()" class="flight_action_btn flex items-center"
        :class="{ 'btn_disabled': !isRTHActionsPossibles, 'active': isRTH }" :title="rthToolTip"
        :disabled="!isRTHActionsPossibles"
        v-if="$root.user.can([2,3,4,5], 'DEVICES.DRC.rth')"
      >
        <span v-if="isRTH" class="flex items-center space-x-1">
          <svg fill="#ffffff" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4">
            <g transform="translate(-598.002 -321.695)">
              <path id="Circle" data-name="Circle"
                d="M614,353.7a16,16,0,1,0-16-16A16,16,0,0,0,614,353.7Zm0-28a12,12,0,1,1-12,12A12,12,0,0,1,614,325.7Z" />
              <rect id="Rectangle" data-name="Rectangle" width="8" height="7.999"
                transform="translate(610.002 333.696)" />
            </g>
          </svg>
          <span>RTH</span>
        </span>
        <span v-else>
          RTH
        </span>
      </button>
    </div>
  </div>


  <!-- :dockId="config.dock.id" -->
</template>

<script>
import { ref } from "vue";
import API from "@/utils/API.js";
import { toast } from "vue3-toastify";

export default {
  name: "Flight_Action",
  components: {
  },
  props: {
    config: Object,
  },
  setup() {
    const openControlPanel = ref(false);
    const isPaused = ref(false);

    return {
      openControlPanel,
      isPaused,
    };
  },

  methods: {
    toogleDroneFrustrum() {
      if (this.config?.drone?.hideFrustrum == undefined) {
        this.config.drone.hideFrustrum = false;
      }

      this.config.drone.hideFrustrum = !this.config.drone.hideFrustrum;
    },

    async supplLight() {
      let data = null;

      var SupplementLight = this.config?.dock?.data?.SupplementLight === 0

      if (SupplementLight) {
        data = await API.put("suppllighton", {
          DevId: this.config.dock.id,
        });

        data.name = "Allumage des LEDs";
      } else {
        data = await API.put("suppllightoff", {
          DevId: this.config.dock.id,
        });

        data.name = "Extinction des LEDs";
      }

      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: data.name,
      };
    },

    async flight_start() {
      this.$root.confirm_open({
        message: this.preflightChecklist(),
        true: async () => {
          let flight_command = await API.put("flightexecute", {
            FlgId: this.config.flight.flg_id,
          });

          this.config.flight.id = flight_command.command;
        },
        false: () => { },
      });
    },

    preflightChecklist() {
      let html =
        `<div class="flex flex-col">
          <h1>`+ this.$e('Lancer la mission ?') +`</h1>

          <div class="text-left my-4">
            <h3 class="border-b w-fit mb-2">`+ this.$e('Checklist') +` : </h3>
        `;

      let valid = `<span class="i float-left !border-success !text-success mr-2">
        <svg class="w-[8px] fill-success" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37.403 29.278">
          <g transform="translate(-172.798 -99.861)">
            <g transform="translate(139.798 37.861)">
              <path d="M70.4,67.183l-24.1,24.1L33,77.97l5.183-5.183,8.125,8.125L65.22,62Z"></path>
            </g>
          </g>
        </svg>
      </span>`

      let warning = `<span class="i float-left !border-warning !text-warning mr-2">?</span>`;

      let error = `<span class="i float-left !border-error !text-error mr-2">
        <svg class="w-[7px] fill-error" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.717 31.717">
          <g transform="translate(-52 -31.8)">
            <g transform="translate(38.2 18)">
              <path d="M40.156,13.8l-10.5,10.5-10.5-10.5L13.8,19.161l10.5,10.5-10.5,10.5,5.361,5.361,10.5-10.5,10.5,10.5,5.361-5.361-10.5-10.5,10.5-10.5Z" transform="translate(0 0)"></path>
            </g>
          </g>
        </svg>
      </span>`

      if (this.$root.global.flight !== undefined) {

        html += `<ul class="text-xs checklist">`

        // === Temps de réponse === //
        if (Object.hasOwnProperty.call(this.$root.global.flight, "LastDockStatus")) {
          let LastDockStatus = parseInt(this.$root.global.flight.LastDockStatus)

          if (LastDockStatus < 1000 * 5) {
            html += `<li>` + valid + this.$e('Réseaux du Dock opérationnel') +`</li>`
          }
          else if (LastDockStatus > 1000 * 5 && LastDockStatus < 1000 * 60) {
            html += `<li>` + warning + this.$e('Réseau du Dock instable') +`</li>`
          }
          else {
            html += `<li>` + error + this.$e('Dock hors ligne') +`</li>`
          }
        }
        else {
          html += `<li>` + error + this.$e('Dock hors ligne') +`</li>`
        }
        // === End Temps de réponse === //

        // === Hauteur de décolage === //
        html += `<li>` + warning + this.$e('Hauteur de décolage') +` : ` + this.flight_info.flg_safeheight + `m</li>`
        // === End Hauteur de décolage === //

        // === BATTERIE 1 === //
        let nvxBatterie1 = false;
        let nvxBatterie2 = false;

        if (Object.hasOwnProperty.call(this.$root.global.flight, "DroneBatt1")) {
          if (this.$root.global.flight.DroneBatt1 < this.flight_info.flg_battmin) {
            html += `<li>` + warning + this.$e('Le niveau de la batterie 1 est inférieur au niveau minimum défini pour la mission') +`. (` + this.flight_info.flg_battmin + `%).</li>`
          }
          else if (this.$root.global.flight.DroneBatt1 <= 10) {
            html += `<li>` + error + this.$e('Le niveau de la batterie 1 est inférieur ou égal à 10 %') +`.</li>`
          }
          else {
            nvxBatterie1 = true;
          }
        }
        // === BATTERIE 2 === //
        if (Object.hasOwnProperty.call(this.$root.global.flight, "DroneBatt2")) {
          if (this.$root.global.flight.DroneBatt2 <= this.flight_info.flg_battmin) {
            html += `<li>` + warning + this.$e('Le niveau de la batterie 2 est inférieur ou égal au niveau minimum défini pour la mission') +`. (` + this.flight_info.flg_battmin + `%).</li>`
          }
          else if (this.$root.global.flight.DroneBatt2 <= 10) {
            html += `<li>` + error + this.$e('Le niveau de la batterie 2 est inférieur ou égal à 10 %') +`.</li>`
          }
          else {
            nvxBatterie2 = true;
          }
        }

        if (nvxBatterie1 && nvxBatterie2) {
          html += `<li>` + valid + this.$e('Niveau de la batterie') +` : ` + this.$root.global.flight.DroneBatt1 + `% `+ this.$e('et') +` ` + this.$root.global.flight.DroneBatt2 + `%.</li>`
        }
        // END BATTERIE  === //


        // === CRON === //
        // if (Object.hasOwnProperty.call(this.flight_info, 'flg_cron') && this.flight_info.flg_cron !== '' && this.flight_info.flg_cron !== null) {
        //   let cron = cronstrue.toString(this.flight_info.flg_cron, {
        //     use24HourTimeFormat: true,
        //     locale: "fr",
        //   });

        //   html += `<li>` + warning + `Vol programmé : ` + cron + `</li>`
        // }
        // === END CRON === //

        // === STORAGE DRONE === //
        // if (
        //   Object.hasOwnProperty.call(this.flight_info, 'flg_stormin') &&
        //   Object.hasOwnProperty.call(this.$root.global.flight, 'DroneStorage') &&
        //   this.flight_info.flg_stormin !== '' &&
        //   this.$root.global.flight !== '' &&
        //   this.$root.global.flight < this.flight_info.flg_stormin
        // ) {
        //   html += `<li>` + warning + `Stockage mémoire du drone inférieur au minimum défini pour la mission</li>`
        // }
        // === END STORAGE DRONE === //

        // html += `<li>` + valid + `Oui non peut etre</li>`
        // html += `<li>` + warning + `Oui non peut etre</li>`
        // html += `<li>` + error + `Oui non peut etre</li>`
        html += "</ul>"
      }
      else {
        html += `<p class="text-sm text-error">` +
          this.$e("Les données permettant de vérifier l'état du drone, du dock ou du réseau n'ont pas pu être récupérées correctement. Nous vous conseillons de patienter un instant et de réessayer.") +
        `</p>`
      }

      return html + '</div></div>';
    },

    async flight_rth() {
      if (this.isRTHActionsPossibles && !this.isRTH) {
        this.$root.confirm_open({
          message: this.$e('Êtes-vous sûr de vouloir démarrer un RTH ?'),
          true: async () => {
            let data = await API.put("flightrth", {
              DevId: this.config.deviceFamilly.this_dev_id
            });

            this.$root.msg_replie[data.command] = {
              id: data.command,
              name: this.$e('RTH en cours'),
            };
          },
          false: () => { },
        });
      }
      else if (this.isRTHActionsPossibles && this.isRTH) {
        if (!$root.user.can([2, 3, 4, 5], 'DEVICES.DRC.rth_cancel')) {
          toast.error(
            this.$e("Vous n'avez pas les droits pour annuler le RTH"),
            $root.toastConfig
          );
          return;
        }

        this.$root.confirm_open({
          message: this.$e("Êtes-vous sûr de vouloir désactiver le RTH ?"),
          true: async () => {
            let data = await API.put("flightrthcancel", {
              DevId: this.config.deviceFamilly.this_dev_id
            });

            this.$root.msg_replie[data.command] = {
              id: data.command,
              name: this.$e("RTH désactivé"),
            };
          },
          false: () => { },
        });
      }
    },

    async flight_pause() {
      this.isPaused = true;
      let data = await API.put("flightpause", {
        FlgId: this.config.flight.flg_id,
      });

      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: this.$e("Mise en pause du vol"),
      };
    },

    async flight_resume() {
      this.isPaused = false;
      let data = await API.put("flightresume", {
        FlgId: this.config.flight.flg_id,
      });

      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: this.$e("Reprise du vol"),
      };
    },

    deviceCanPlayMission() {
      return this.$root.device_can_play_mission.hasOwnProperty(this.config.deviceFamilly.this_det_id);
    },

    async fireParachute() {
      this.$root.confirm_open({
        message: this.$e("Êtes-vous sûr de vouloir déclencher le parachute ?"),
        true: async () => {
          let data = await API.put("ftsfire", {
            DevId: this.config?.deviceFamilly?.this_dev_id,
          });

          this.$root.msg_replie[data.command] = {
            id: data.command,
            name: this.$e("Déclenchement du parachute"),
          };
        },
        false: () => { },
      });
    },
  },

  computed: {
    drcModeCss() {
      let LastPing = this.config?.drone?.status?.LastPing != null
        ? parseInt(this.config.drone.status.LastPing)
        : ENV.DEVICE_OFFLINE;

      if (LastPing >= ENV.DEVICE_OFFLINE) {
        return '';
      }

      switch (this.config?.dock?.status?.drc_state) {
        case 0:
          return "border-[#2D5C88]";
        case 1:
          return "border-[#FFA100]";
        case 2:
          return "border-[#4BDE40]";
        default:
          return "";
      }
    },

    isRTH() {
      return this.config.drone?.status?.mode_code !== undefined
        ? this.config.drone.status.mode_code == 9
        : false;
    },

    isRTHActionsPossibles() {
      return [3, 5, 6, 7, 8, 9, 15, 16, 17, 18, 19, 20].includes(this.config.drone?.status?.mode_code);
    },

    rthToolTip() {
      if (this.isRTHActionsPossibles) {
        return this.isRTH ? this.$e("Annuler le RTH") : this.$e("Lancer un RTH");
      }
      else {
        return this.$e('Action RTH impossible');
      }
    },

    light() {
      return this.$root.global.flight !== undefined &&
        Object.hasOwnProperty.call(this.$root.global.flight, "SupplementLight")
        ? this.$root.global.flight.SupplementLight == 1
        : false;
    },

    canStart() {
      return !Number.isInteger(this.config?.flight?.id);
    },

    canResumeOrPause() {
      return Number.isInteger(this.config?.flight?.id);
    },

    DroneLastPingAreOnline() {
      let LastPing = this.config?.drone?.status?.LastPing != undefined
        ? parseInt(this.config.drone.status.LastPing)
        : 999999;

      return LastPing < ENV.DEVICE_OFFLINE;
    },

    haveParachute() {
      return this.config?.parachute?.id != undefined;
    },
  },
};
</script>
